import { Button, Col, Form, Input, notification, Popconfirm, Row, Spin, Switch, Table } from "antd";
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react";
import { API_ERR_MESSAGE, CHARACTER_PATTERN, CHARACTER_PATTERN_MESSAGE } from "../../../../../config/constant";
import { addWeightLossApi, listOfWeightLossApi, updateWeightLossApi } from "../../../../../config/Api";

export const ReasonOfWeightLoss = () => {

    const [dataSource, setDataSource] = useState([]);
    const [displayData, setDisplayData] = useState([]);
    const [isActive, setIsActive] = useState(false)
    const [buttonName, setButtonName] = useState('ADD')
    const [ReasonOfWeightLossData, setReasonOfWeightLossData] = useState()
    const [editReasonOfWeightLossRecord, setEditReasonOfWeightLossRecord] = useState()
    const [loading, setLoading] = useState(false)

    const [form] = Form.useForm();

    // get the list of all available reson of weight loss data
    //============================== 
    const getListOfReasonOfWeightLoss = () => {
        setLoading(true)

        listOfWeightLossApi()
            .then((res) => {
                if (res.status === 200) {
                    setDataSource(res.data.data);
                    setDisplayData(res.data.data);
                }
                setLoading(false)
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                });
            });
    }

    // call when user click on edit
    //==============================
    const editReasonOfWeightLoss = (data) => {
        setButtonName("UPDATE")
        form.setFieldsValue({ 'reason': data.reason })
        setEditReasonOfWeightLossRecord(data);
    }

    useEffect(() => {
        getListOfReasonOfWeightLoss()
    }, []);

    // filter data according to user search input 
    //==============================
    useEffect(() => {
        filterReasonOfWeightLoss(ReasonOfWeightLossData);
    }, [ReasonOfWeightLossData]);

    // filter Reason Of Weight Loss 
    //==============================
    const filterReasonOfWeightLoss = (data) => {
        if (!data) {
            setDisplayData(dataSource);
        } else {
            let tmp = [];
            dataSource.length > 0 && dataSource.forEach((element) => {
                if (element.reason.toUpperCase().indexOf(data.toUpperCase()) !== -1) {
                    tmp.push(element);
                }
            });
            setDisplayData(tmp);
        }
    };

    // update status of Reason Of Weight Loss 
    //==============================
    const onChange = (checked, data) => {
        let updatedData = data;
        updatedData.status = checked;

        updateWeightLossApi(data.id, updatedData)
            .then((res) => {
                if (res.status == 200) {
                    notification.success({
                        message: "Weight Loss Reason Update successfully",
                    });
                    getListOfReasonOfWeightLoss()
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    };

    // handle submit 
    //==============================
    const onFinish = (values) => {

        if (buttonName == 'ADD') {
            const data = {
                "reason": values.reason,
                "status": true
            }
            addWeightLossApi(data)
                .then((res) => {
                    if (res.status == 200) {
                        form.setFieldsValue({ 'reason': '' })
                        notification.success({
                            message: "Reason Of Weight Loss added successfully",
                        });
                        getListOfReasonOfWeightLoss()
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
        else {
            const data = {
                "reason": values.reason,
                "status": values.status
            }
            updateWeightLossApi(editReasonOfWeightLossRecord.id, data)
                .then((res) => {
                    if (res.status == 200) {
                        setButtonName("ADD")
                        notification.success({
                            message: "Weight Loss Reason Update successfully",
                        });
                        getListOfReasonOfWeightLoss()
                        form.setFieldsValue({ 'reason': '' })
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
    };

    const columns = [
        {
            title: 'Reason',
            dataIndex: 'reason',
            key: 'reason',
            render: (text) => <a>{text}</a>,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text, data) => <>
                <Switch checked={text} onChange={(e) => { setIsActive(!isActive); onChange(e, data) }} />
            </>,
            filters: [
                { text: "Active", value: true },
                { text: "DeActive", value: false },
            ],
            onFilter: (value, record) => record.status == value,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <div className="action align-self-center">
                    <Button icon={<EditOutlined />} onClick={(e) => { setButtonName('UPDATE'); editReasonOfWeightLoss(record) }} className="me-2" />
                    <Popconfirm title="Sure to delete?" >
                        <Button icon={<DeleteOutlined />} />
                    </Popconfirm>
                </div>
            ),
        },
    ];
    const data = [
        {
            id: '1',
            reason: 'None',
            status: true
        },
        {
            id: '2',
            reason: 'Diet',
            status: false
        },
        {
            id: '3',
            reason: 'Exercise',
            status: true
        },
        {
            id: '4',
            reason: 'Atkins',
            status: true
        },
        {
            id: '5',
            reason: 'Gluten Free Diet',
            status: true
        }
    ];

    const resetData = () => {
        form.resetFields()
    };
    return (
        <div className="ReasonOfWeightLoss">
            <Row>
                <Col xl={14}>
                    <Form
                        name="addReasonOfWeightLossForm"
                        // className="addReasonOfWeightLossForm"
                        form={form}
                        onFinish={onFinish}
                    >
                        <Row className="addReasonOfWeightLossForm">
                            <Col xl={8}>
                                <Form.Item
                                    name="reason"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Enter Reason For Weight Loss!",
                                        },
                                        {
                                            pattern: CHARACTER_PATTERN,
                                            message: CHARACTER_PATTERN_MESSAGE,
                                        }
                                    ]}
                                >
                                    <Input placeholder="Enter Reason For Weight Loss" className="p-2" />
                                </Form.Item>
                            </Col>
                            <Col xl={8}>
                                <Button htmlType="submit" className="submit-button  border-0 rounded ms-2" icon={buttonName == 'ADD' ? <PlusOutlined style={{ fontSize: "1.2rem" }} /> : <EditOutlined style={{ fontSize: "1rem" }} />}
                                >
                                    {buttonName}
                                </Button>
                            </Col>
                        </Row>

                    </Form>

                </Col>
                <Col xl={4} className="text-end align-self-center">
                    <h6>Total : {displayData.length > 0 ? displayData.length : 0} </h6>
                </Col>
                <Col xl={6} className="align-self-center">
                    <Input.Search placeholder="Search Reason Of Weight Loss"
                        onChange={(e) => { filterReasonOfWeightLoss(e.target.value); setReasonOfWeightLossData(e.target.value) }}
                        className="p-2" />
                </Col>
            </Row>
            <Spin spinning={loading} className="spinner-code">
            <Row>
                <Table
                    columns={columns}
                    rowKey="id"
                    dataSource={displayData}
                    // pagination={false}
                    scroll={{ x: "max-content" }}
                    className="w-100"
                />
            </Row>
            </Spin>
        </div>
    )
}
